module.exports = __webpack_public_path__ + "static/media/04.9696fbe4.jpg";